(function () {
  "use strict";

  function initCarousel(section) {
    var container = section.querySelector(".reviews-carousel-splide");
    if (!container || container._splide) return;

    var prevButton = section.querySelector(".global-nav-button.prev, .nav-button.prev");
    var nextButton = section.querySelector(".global-nav-button.next, .nav-button.next");

    container.classList.remove("reviews-carousel-splide--pending");

    var centerDesktop = section.dataset.centerCardsDesktop === "true";
    var centerMobile = section.dataset.centerCardsMobile === "true";
    var slideCount = container.querySelectorAll(".splide__slide").length;
    var isMobile = window.innerWidth < 768;
    var initialSlide = (isMobile ? centerMobile : centerDesktop) ? Math.floor(slideCount / 2) : 0;
    var GAP = 12;

    var splide = new window.Splide(container, {
      autoWidth: true,
      gap: GAP,
      loop: false,
      speed: 400,
      focus: centerMobile ? "center" : 0,
      start: initialSlide,
      arrows: false,
      pagination: false,
      mediaQuery: "min",
      breakpoints: {
        768: { focus: centerDesktop ? "center" : 0 },
      },
    });

    if (prevButton) prevButton.addEventListener("click", function () { splide.go("<"); });
    if (nextButton) nextButton.addEventListener("click", function () { splide.go(">"); });

    var updateFit = function () {
      var slides = container.querySelectorAll(".splide__slide");
      if (!slides.length) return;
      var total = 0;
      slides.forEach(function (s) { total += s.getBoundingClientRect().width; });
      total += GAP * (slides.length - 1);
      var fits = total <= container.clientWidth + 1;
      var centerAllowed = window.innerWidth >= 768 ? centerDesktop : centerMobile;
      section.classList.toggle("reviews-fits", fits && centerAllowed);
    };

    var updateNav = function () {
      var index = splide.index;
      var end = splide.Components.Controller.getEnd();
      if (prevButton) prevButton.classList.toggle("nav-button-disabled", index === 0);
      if (nextButton) nextButton.classList.toggle("nav-button-disabled", index >= end);
      updateFit();
    };

    splide.on("mounted moved", updateNav);

    splide.on("resized", function () {
      updateFit();
      var isDesktop = window.innerWidth >= 768;
      var target = (isDesktop ? centerDesktop : centerMobile) ? Math.floor(slideCount / 2) : 0;
      setTimeout(function () { splide.go(target); updateFit(); }, 50);
    });

    splide.mount();
    container._splide = splide;
  }

  function runInit() {
    var sections = document.querySelectorAll(".reviews-transformation-section");
    sections.forEach(function (section) {
      if (section.querySelector(".reviews-carousel-splide")) {
        initCarousel(section);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInit);
  } else {
    runInit();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var section = e.target.querySelector && e.target.querySelector(".reviews-transformation-section");
    if (section) {
      initCarousel(section);
    } else if (e.target.classList && e.target.classList.contains("reviews-transformation-section")) {
      initCarousel(e.target);
    }
  });
})();
